import { render } from "./ImageUpload.vue?vue&type=template&id=669f3e5e&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=669f3e5e&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669f3e5e"]])

export default __exports__